// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class ListActiveServicePointsRequest extends ETagRequest {

    public lat: number | null = null;

    public lon: number | null = null;

    public readonly isListActiveServicePointsRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ListActiveServicePointsRequest) || ((from as any).isListActiveServicePointsRequest === true));
    }

    public static as(from?: object | null): ListActiveServicePointsRequest | null {
        return (ListActiveServicePointsRequest.is(from)) ? from as ListActiveServicePointsRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ListActiveServicePointsRequest, "ListActiveServicePointsRequest");